import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'react-jss'
import {
  BrowserRouter,
  Switch,
  Route,
} from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'
import store from './utils/store'
import theme from './utils/theme'
import client from './utils/graphqlClient'
import { saveState } from './utils/localStorage'
import {
  MainLayout,
  AdminLayout,
} from './modules/'

store.subscribe(() => {
  saveState({
    admin: store.getState().admin,
    selection: store.getState().selection,
    offer: {
      prefill: store.getState().offer.prefill,
    },
  })
})

export default () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ApolloProvider client={client}>
          <Switch>
            <Route
              path="/admin"
              component={AdminLayout}
            />
            <Route
              path="/"
              component={MainLayout}
            />
          </Switch>
        </ApolloProvider>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
)



// WEBPACK FOOTER //
// ./src/App.jsx